export function syncStcSelectDisplay(select: HTMLSelectElement): void {
  const selectRoot = select.closest<HTMLElement>('[data-stc-select]');
  if (!selectRoot) return;

  const valueEl = selectRoot.querySelector<HTMLElement>('.stc-select__value');
  const options = selectRoot.querySelectorAll<HTMLElement>('.stc-select__option');
  const selectedOption = select.options[select.selectedIndex];

  if (valueEl) {
    valueEl.textContent = selectedOption?.text ?? '';
  }

  options.forEach((option) => {
    const isSelected = option.dataset.value === select.value;
    option.classList.toggle('is-selected', isSelected);
    option.setAttribute('aria-selected', String(isSelected));
  });
}

export function initStcSelect(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-stc-select]').forEach((selectRoot) => {
    if (selectRoot.dataset.stcSelectBound === 'true') {
      return;
    }
    selectRoot.dataset.stcSelectBound = 'true';

    const select = selectRoot.querySelector<HTMLSelectElement>('.stc-select__native');
    const trigger = selectRoot.querySelector<HTMLButtonElement>('.stc-select__trigger');
    const valueEl = selectRoot.querySelector<HTMLElement>('.stc-select__value');
    const menu = selectRoot.querySelector<HTMLElement>('.stc-select__menu');
    const options = selectRoot.querySelectorAll<HTMLElement>('.stc-select__option');

    if (!select || !trigger || !valueEl || !menu) {
      return;
    }

    const updateDisplay = (): void => {
      const selectedOption = select.options[select.selectedIndex];
      valueEl.textContent = selectedOption?.text ?? '';

      options.forEach((option) => {
        const isSelected = option.dataset.value === select.value;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', String(isSelected));
      });
    };

    const close = (): void => {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      selectRoot.classList.remove('is-open');
    };

    const open = (): void => {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      selectRoot.classList.add('is-open');
    };

    trigger.addEventListener('click', () => {
      if (selectRoot.classList.contains('is-open')) {
        close();
        return;
      }

      open();
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        select.value = option.dataset.value ?? '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
        updateDisplay();
        close();
      });
    });

    document.addEventListener('click', (event) => {
      if (!selectRoot.contains(event.target as Node)) {
        close();
      }
    });

    select.addEventListener('change', updateDisplay);
    updateDisplay();
  });
}
